import type { RouteRecordRaw } from 'vue-router';

export const wishRoutes: Array<RouteRecordRaw> = [
  {
    path: '/wish',
    name: 'wish',
    redirect: '/wish/list',
    component: () => import('pages/trade/admin/wish/TradeWish.vue'),
    meta: {
      title: 'Wishes',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'wishList',
        component: () => import('pages/trade/admin/wish/WishList.vue'),
        meta: {
          title: 'Wishes List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'wishDetail',
        component: () => import('pages/trade/admin/wish/WishDetail.vue'),
        meta: {
          title: 'Wish Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'wishNew',
        component: () => import('pages/trade/admin/wish/WishNew.vue'),
        meta: {
          title: 'New Wish',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'wishExplorer',
        component: () => import('pages/trade/admin/wish/WishExplorer.vue'),
        meta: {
          title: 'Wishes Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
